
@if (passwordStore.flowBranch === flowBranchEnum.login) {
  @if (trackPageView && !passwordStore.errorCode) {
    <ng-container ssTrackEvent [event]="track.loginPasswordInputPageView">
    </ng-container>
  }
  <h1 class="text-title-4 mb-8" translate>{{signInHeader}}</h1>
  <p class="mb-24 text-body-lg" translate>{{headerHolder}}</p>
  @if (client !== "r4b") {
    <p class="text-body mb-2 text-bold">  {{ username }}</p>
  }
  @if (client == "r4b") {
    <p class="text-body mb-24 text-bold">  {{ username }}</p>
  }
  @if (showChangeUsername) {
    <a
      ds-link
      variant="cta"
      class="mb-24 ds-color-link"
      attr.title="{{ changeUsernameAttr | translate }}"
      (click)="routeLink('changeUsername')">
    {{ changeUsernameTitle | translate }}</a>
  }
  @if (passwordStore.errorCode) {
    <div class="mb-16">
      <ds-alert
        variant="error"
        [closeLabel]="'rogers.login.popOverClose' | translate"
        (closeClick)="resetErrorMessage()"
        role="alert"
        ssTrackError
        [error]="track.loginPasswordApiErrors">
        <div class="d-flex flex-column flex-md-row">
          <div class="flex-grow-1 d-flex">
            <ds-icon
              class="mr-8"
              name="error-outlined"
              color="error"
              [ariaHidden]="false"
              [attr.title]="'rogers.login.accessibility.error' | translate"
              caption="Attention">
            </ds-icon>
            <div>
              @if (passwordStore.errorCode === "UE03") {
                <p
                  damTranslationWithRouting
                  class="text-body mb-0 mw-content">
                  @if ((client === 'shaw' || client === 'shaw_direct' || client === 'shaw_enterprise')) {
                    <span>
                      {{ 'shaw.errors.password' | translate }}
                      <a
                        href="https://www.rogers.com/support/billing-accounts/shaw-billing/rogers-together-with-shaw#billing-and-account-faq"
                        variant="cta"
                        class="mb-0 ds-color-link"
                        [attr.title]="'shaw.errors.learnMore' | translate"
                        target="_blank"
                        style = "cursor: pointer;">
                      {{ 'shaw.errors.learnMore' | translate }}</a>
                    </span>
                  }
                  @if ((client !== 'homeconnect_shaw' && !igniteUserSelectedBrand
                    && client !== 'shaw' && client !== 'shaw_direct' && client !== 'shaw_enterprise')
                    && xfinitySelectedBrand !== 'shaw') {
                    <span>
                      {{ 'rogers.errors.' + passwordStore.errorCode | translate }}
                      @if (errCode) {
                        <a href="javascript:void(0)"
                          variant="cta"
                          class="mb-0 ds-color-link"
                          [attr.title]="'common.accessibility.forgotPassword' | translate"
                          (click)="onForgotPasswordClick()">
                        {{ 'rogers.errors.forgotPassword' | translate }}</a>
                      }
                      {{ errCode | translate }}
                    </span>
                  }
                  @if ((client === 'ignitetv' && igniteUserSelectedBrand) || client === 'homeconnect_shaw') {
                    <span>
                      <span [ngClass]="igniteUserSelectedBrand === 'shaw' && currentLang === 'fr' ? 'shaw-username' : ''">
                        {{ (igniteUserSelectedBrand === 'rogers') ?
                        ('rogersShaw.errors.password' | translate) :
                        ('rogersShaw.errors.shawPassword' | translate)  }}
                      </span>
                      @if (errCode) {
                        <a href="javascript:void(0)"
                          class="mb-0 ds-color-link forgot-pwd-link"
                          [attr.title]="'common.accessibility.forgotPassword' | translate"
                          (click)="onForgotPasswordClick()">
                          {{ (igniteUserSelectedBrand === 'rogers') ?
                        ('rogersShaw.errors.forgotPassword' | translate) : '' }}</a>
                      }
                      @if (igniteUserSelectedBrand === 'rogers') {
                        <span class="forgot-pwd">.</span>
                      }
                      <span>
                        {{client === 'homeconnect_shaw' ? ('homeconnect.errors.password' | translate) :
                        (igniteUserSelectedBrand === 'shaw') ?
                        ('rogersShaw.rogers.errors.shawTvPassword' | translate)
                        :('rogersShaw.shaw.errors.rogersTv' | translate)  }}
                        {{client !== 'homeconnect_shaw' ? ('rogersShaw.errors.signInHere' | translate) : '' }}
                      </span>
                    </span>
                  }
                  @if ((client === 'xfinity' && xfinitySelectedBrand === 'shaw')) {
                    <span>
                      {{'xfinity.errors.password' | translate  }}
                    </span>
                  }
                </p>
              } @else {
                <p
                  damTranslationWithRouting
                  class="text-body mb-0 mw-content">
                  {{ 'rogers.errors.' + passwordStore.errorCode | translate }}
                </p>
              }
            </div>
          </div>
        </div>
      </ds-alert>
    </div>
  }
  <!-- Password Form  -->
    <div class="mb-16" *ngIf="(passkeyCancelError === 'failed' || passkeyAuthError === 'fail')">
    <ds-alert
      variant="error"
      [closeLabel]="'rogers.login.popOverClose' | translate"
      (closeClick)="resetErrorMessage()"
      role="alert"
      ssTrackError
      [error]="track.loginPasswordApiErrors">
      <div class="d-flex flex-column flex-md-row">
        <div class="flex-grow-1 d-flex">
          <ds-icon
            class="mr-8"
            name="error-filled"
            color="error"
            [ariaHidden]="false"
            [attr.title]="'rogers.login.accessibility.error' | translate"
            caption="Attention">
          </ds-icon>
            <div>
             <p class="text-body">
            <span>
              <div>
                <b>{{'passkey.signIn.passwordErrorHeader' | translate}}</b>
              </div>
              <div style="margin-left: -30px;">
               {{ 'passkey.signIn.passwordError' | translate }}
              </div>
            </span>
            </p>
          </div>
        </div>
      </div>
    </ds-alert>
  </div>

<!-- Password Form  -->
  <form
    [formGroup]="loginForm"
    (ngSubmit)="validateAndSubmit()"
    #loginFormRef
    id="LoginForm"
    method="POST"
    novalidate
    >
    <div class="hidden-username">
      <ds-form-field>
        <ds-input-label>{{ 'common.username' | translate }}</ds-input-label>
        <input
          dsInput
          type="email"
          formControlName="username"
          />
        </ds-form-field>
      </div>
      <div>
        <ds-form-field>
          <ds-input-label>{{ 'common.password' | translate }}</ds-input-label>
          <input
            [showPasswordToggleButton]="false"
            [attr.type]="showNewPassword ? 'password' : 'text'"
            type="password"
            dsInput
            [(ngModel)]="code"
            #passwordInput
            id="input_password"
            class="round-input"
            formControlName="input_password"
            name="input_password"
            autocapitalize="off"
            spellcheck="false"
            [attr.autocorrect]="'off'"
            autocomplete="current-password"
            (keydown.enter)="keyDownEnter($event)"
            (keydown.space)="$event.preventDefault()"
            autofill
        [attr.title]="
            'common.passwordAttr' | translate
          "
            [attr.aria-required]="true"
            [attr.aria-invalid]="false"
        [attr.aria-label]="
            'rogers.login.accessibility.showPassword' | translate
          "
            />
            <button
              dsSuffix
              ds-button
              type="button"
              variant="icon"
              [attr.aria-pressed]="!showNewPassword"
              (click)="showNewPassword = !showNewPassword"
        title="{{
            showNewPassword
              ? ('common.showPasword' | translate)
              : ('common.hidePassword' | translate)
          }}"
              >
              <ds-icon [name]="showNewPassword ? 'hide' : 'show'"></ds-icon>
            </button>
            @if (passwordFormError) {
              <ds-error
                errorMessage="{{ 'rogers.errors.ECA3' | translate }}"
                alt="Attention"
                role="alert"
                ssTrackError
                [error]="track.loginPasswordInputFormError"
              ></ds-error>
            }
          </ds-form-field>
        </div>
        @if (!accountLocked) {
          <div style="margin-top: 5px;">
            @if (((client === "ignitetv" || client === "homeconnect_shaw")
              || igniteUserSelectedBrand === "shaw") ) {
              <p class="mt-16 mb-16">
              </p>
            } @else {
              <a
                ds-link
                variant="cta"
                class="mb-16 ds-color-link"
                [attr.title]="'common.accessibility.forgotPassword' | translate"
                (click)="onForgotPasswordClick()">
              {{ 'common.forgotPassword' | translate }}</a>
            }
          </div>
        }
        @if (accountLocked) {
          <div  class="mt-5 mb-16"></div>
        }
        <div class="text-center signInButton ">
          <button
            ds-button
            role="button"
            class="w-100 mb-16"
            type="submit"
            #loginBtn
            title="{{ signinAttr | translate }}"
            >
            @if (!loginInProgress) {
              <span>{{
                'rogers.login.signin' | translate
              }}</span>
            }
            @if (loginInProgress) {
              <eas-loader class="eas-loader" ssTrackEvent [event]="track.loginSigninAttempt"></eas-loader>
            }
          </button>
        </div>
      </form>
    }


